import React from "react";
import { useChat } from "../../../../context/contextChat";

const ChatIcon = () => {
  const { setShowChat } = useChat();

  return (
    <button
      onClick={() => setShowChat(true)}
      className="d-flex justify-content-center align-items-center rounded-circle border-0 shadow-sm"
      style={{
        width: 50,
        height: 50,
        background: "#344266",
        cursor: "pointer",
        // zIndex: 1055
      }}
      aria-label="Open Chat"
    >
      <i className="bi bi-chat-dots-fill fs-4 text-white z-1"></i>
    </button>
  );
};

export default ChatIcon;
